import { Button, Modal } from 'react-bootstrap'
import { useAtomValue, useSetAtom } from 'jotai'
import * as lib from '../../lib'
import * as state from '../../states'
import { IAccount, ETableRemoveType } from '../../types'
import { NotSystemItems, ItemBox, IdBox, ModalBodyBox } from '../role'
import { ALL_LANG_KEY } from '../../types/lang'
import React from 'react'
import { useTranslation, Trans } from 'react-i18next'

type IAccountRemoveModalBase = {
	show: boolean;
	onClose: () => void;
	onSave: () => void;
}

type IAccountRemoveModalProps = IAccountRemoveModalBase & {
	type: ETableRemoveType.single;
	item: IAccount | null;
}

type IAccountsRemoveModalProps = IAccountRemoveModalBase & {
	type: ETableRemoveType.multi;
	items: IAccount[] | null;
}

export const AccountRemoveModal = (
	props: IAccountRemoveModalProps | IAccountsRemoveModalProps
) => {
	const { t } = useTranslation()
	const tokens = useAtomValue(state.tokensAtom)
	const access = tokens?.access ?? null
	const setFetchIsLoading = useSetAtom(state.fetchIsLoadingAtom)

	const { type, show, onClose, onSave } = props

	const isTypeSingle = type === ETableRemoveType.single
	const item = type === ETableRemoveType.single ? props.item : null
	const items = type === ETableRemoveType.multi ? props.items : null
	const ids = items?.map(item => item?.id ?? 0) ?? []

	if (!show) {
		return null
	}

	const onRemove = async () => {
		const accountId: number = item?.id ?? 0
		//const uri: string = isTypeSingle ? `account/${accountId}?force=true` : `account?ids=${ids}&force=true` --- HARD DELETE FROM DATA BASE
		const uri: string = isTypeSingle ? `account/${accountId}` : `account?ids=${ids}`
		const method: string = 'DELETE'
		const params: lib.FetchOptions['params'] = {}
		const headers = lib.bearer(access)
		const options: lib.FetchOptions = { method, params, headers }

		try {
			setFetchIsLoading(state.turnOnLoader)
			const response = await lib.fetching<void>(uri, options)
			onSave()
			//TODO: check response for each item (true/false) ...?!
			//console.log('onRemove: ', {response})
			if ((response as any)?.result) {
				const resObj = (response as any)?.result ?? {}
				const resEntries = Object.entries(resObj)
				const isSomeError = resEntries?.some(([key, value]) => !value)

				if (isSomeError) {
					throw resObj
				}
			}
		} catch (error: unknown) {
			// TODO: pretty notification alert
			console.error(error)
		} finally {
			setFetchIsLoading(state.turnOffLoader)
		}
	}

	const renderSingleItem = () => {
		const itemLabel = item?.email ? `${item?.email} (${item?.role?.name})` : '?'

		return (
			<NotSystemItems>
				<Trans
					i18nKey={ALL_LANG_KEY.account_crud_modal.title_remove_single}
					components={{ span: <span className={'text-danger'}/> }}
				/>:
				<br/>
				<br/>
				<ItemBox key={`account-${item?.id}`}
					// className={'text-danger'}
				>
					- <IdBox className={'text-danger'}>[id: {item?.id}]</IdBox> {itemLabel}
				</ItemBox>
			</NotSystemItems>
		)
	}

	const renderMultiItems = () => {
		if (!items?.length) return null

		return (
			<NotSystemItems>
				<Trans
					i18nKey={ALL_LANG_KEY.account_crud_modal.title_remove_multiple_cnt}
					components={{
						span: <span className={'text-danger'}/>,
						cnt: items?.length ?? ''
					}}
				/>:
				<br/>
				<br/>
				{items?.map((item, index) => {
					const itemLabel = item?.email ? `${item?.email} (${item?.role?.name})` : '?'

					return (
						<ItemBox key={`account-${item?.id ?? index}`}
							// className={'text-danger'}
						>
							- <IdBox className={'text-danger'}>[id: {item?.id}]</IdBox> {itemLabel}
						</ItemBox>
					)
				})}
			</NotSystemItems>
		)
	}

	const modalTitle = (
		<Trans
			i18nKey={isTypeSingle ? ALL_LANG_KEY.account_crud_modal.title_remove_single : ALL_LANG_KEY.account_crud_modal.title_remove_multiple}
			components={{ span: <></> }}
		/>
	)
	const modalBody = isTypeSingle ? (
		<>
			{renderSingleItem()}
		</>
	) : (
		<>
			{renderMultiItems()}
		</>
	)
	const msgRemoveConfirm = `${t(ALL_LANG_KEY.account_crud_modal.msg_remove_confirm)}`

	return <>
		<Modal show={show}
		       onHide={onClose}
		       scrollable={true}
		       size={'lg'}
		>
			<Modal.Header closeButton>
				<Modal.Title>{modalTitle}</Modal.Title>
			</Modal.Header>

			<Modal.Body className={'scroll'}>
				<ModalBodyBox className={'fs-25'}>
					{modalBody}
					<span className={'text-primary'}>{msgRemoveConfirm}</span>
				</ModalBodyBox>
			</Modal.Body>

			<Modal.Footer>
				<Button variant="primary" onClick={onRemove}>{`${t(ALL_LANG_KEY.account_crud_modal.btn_remove)}`}</Button>
				<Button variant="secondary" onClick={onClose}>{`${t(ALL_LANG_KEY.account_crud_modal.btn_close)}`}</Button>
			</Modal.Footer>
		</Modal>
	</>
}
